import './Header.css'
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';

import { faChalkboardTeacher, faSignInAlt, faHome, faInbox, faListOl, faSignOutAlt, faFolder, faUser, faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import routes from '../../../constants/routes';

import { getUserDataAction } from '../../../actions/authActions';
import { unselectJurisdictionAction } from '../../../actions/proceedingActions';
import { removeJwtToken } from '../../../helpers/authHelper';
import es from '../../../lang/es';


const Header = () => {
    //Inicializo el dispatch
    const dispatch = useDispatch();
    const history = useHistory();
    //Traigo del store
    const user = useSelector(state => state.auth.user);
    //Verifico si hay datos al inicio
    useEffect(() => {
        //Si no hay datos, debo buscarlos
        if(!user){
            loadData();
        }
    }, []);
    //Cargo datos
    const loadData = () => {
        //Llamo al dispatch
        dispatch( getUserDataAction() );
    }
    //Manejo el logout
    const handleLogout = () => {
        removeJwtToken();
        //Redirecciono
        window.location = `${process.env.REACT_APP_LOGIN_URL}/logout`;
    }
    //Manejo la redirección
    const handleRedirectHome = e => {
        e.preventDefault();
        //Limpio
        dispatch( unselectJurisdictionAction() );
        //Redirecciono
        history.push(routes.HOME);
    }
    //Render
    return (
        <Navbar expand="md" variant="light" bg="light" sticky="top" className="shadow mb-3">
            <Navbar.Brand href={ process.env.REACT_APP_LOGIN_URL }>
                <img
                    src="/img/logos/logo-72.png"
                    width="30"
                    height="30"
                    className="d-inline-block align-top"
                    alt={ process.env.REACT_APP_NAME }
                />
                <span className="ml-2">
                    <b className="h5">{ process.env.REACT_APP_NAME_ALT }</b>
                </span>
            </Navbar.Brand>
            <Navbar.Toggle  aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                    <Nav.Link onClick={ handleRedirectHome }>
                            <FontAwesomeIcon icon={faHome} />
                            <span className="ml-1 d-md-none">Inicio</span>
                    </Nav.Link>
                    <NavDropdown title={<><FontAwesomeIcon icon={faBars} /> Aplicaciones</>} id="aplications">
                        <NavDropdown.Item href={ process.env.REACT_APP_QA_PS }>
                            <FontAwesomeIcon icon={faListOl} />
                            <span className="ml-1">Protocolo Sentencias</span>
                        </NavDropdown.Item>
                        <NavDropdown.Item href={ process.env.REACT_APP_QA_EJ }>
                            <FontAwesomeIcon icon={faInbox} />
                            <span className="ml-1">Estrado Judicial</span>
                        </NavDropdown.Item>
                        <NavDropdown.Item href={ process.env.REACT_APP_QA_TN }>
                            <FontAwesomeIcon icon={faChalkboardTeacher} />
                            <span className="ml-1">Instructivos y Formularios</span>
                        </NavDropdown.Item>
                    </NavDropdown>

                    {
                        user ? (
                            <LinkContainer to={routes.MY_PROCEEDINGS}>
                                <Nav.Link>
                                    <FontAwesomeIcon icon={ faFolder } /> { es.MY_PROCEEDINGS }
                                </Nav.Link>
                            </LinkContainer>
                        ) : null
                    }
                </Nav>
            </Navbar.Collapse>
            <Navbar.Collapse className="justify-content-end">
            <Nav>
                {
                    user ? (
                        <NavDropdown title={<><FontAwesomeIcon icon={faUser} /> <span className="ml-1">{user ? `${user.lastname}, ${user.name}` : '-'}</span></>} id="profileMenuId" alignRight>
                            <NavDropdown.Item data-cy="logout-link" onClick={handleLogout}>
                                <FontAwesomeIcon icon={faSignOutAlt} />
                                <span className="ml-1">Cerrar Sesión</span>
                            </NavDropdown.Item>
                        </NavDropdown>
                    ) : (
                        <Nav.Item className="mr-0">
                            <a href={ process.env.REACT_APP_LOGIN_URL } className="btn btn-success text-white">
                                <FontAwesomeIcon icon={ faSignInAlt } /> { es.LOGIN }
                            </a>
                        </Nav.Item>
                    )
                }
            </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

export default Header;